import { MusicNotes, SpeakerSlash } from "@phosphor-icons/react";
import { useKidsSound } from "@/hooks/useKidsSound";
import { NoCookieYouTube } from "@/components/kids/NoCookieYouTube";

// Hosted YouTube sing-along: plain youtube-nocookie.com embed (no IFrame API, no autoplay).
// Volume is controlled inside the YouTube player; the Kids Corner Sound toggle only affects Lumi's voice.
const PANEL = "bg-white rounded-3xl border border-[#e6ddfa] shadow-[0_8px_30px_rgba(115,88,179,0.10)]";

export const SingAlong = ({ videoId, title, description, heading = "Sing Along with Lumi" }) => {
  const [soundOn] = useKidsSound();

  return (
    <section className="mt-12" aria-labelledby="singalong-title" data-testid="sing-along">
      <h2 id="singalong-title" className="font-nunito font-extrabold text-2xl sm:text-3xl text-[#4a2e8a] mb-5 inline-flex items-center gap-3">
        <span className="w-11 h-11 rounded-2xl bg-[#efe9fb] flex items-center justify-center"><MusicNotes size={24} weight="fill" className="text-[#6a3fc7]" /></span>
        {heading} <span aria-hidden="true" className="text-[#f2b544] text-xl">✦</span>
      </h2>
      <div className={`${PANEL} overflow-hidden grid lg:grid-cols-5`} data-testid="sing-along-card">
        <div className="lg:col-span-3 bg-black">
          <div className="relative aspect-video w-full" data-testid="sing-along-player">
            <NoCookieYouTube videoId={videoId} title={title} captions testId="sing-along-iframe" />
          </div>
        </div>
        <div className="lg:col-span-2 p-6 sm:p-8 flex flex-col justify-center gap-3 bg-gradient-to-br from-[#f7f4fd] to-[#efe9fb]">
          <h3 className="font-nunito font-extrabold text-xl sm:text-2xl text-[#4a2e8a]" data-testid="sing-along-title">{title}</h3>
          <p className="font-nunito text-base text-[#5b5572] leading-relaxed" data-testid="sing-along-description">{description}</p>
          <p className="font-nunito text-sm text-[#7a748f]">Press play on the video to begin. Lyrics appear as captions (CC). Use the video’s own volume button to adjust sound.</p>
          {!soundOn && (
            <p className="inline-flex items-center gap-1.5 font-nunito text-sm text-[#6a3fc7]" data-testid="sing-along-sound-off-note">
              <SpeakerSlash size={16} weight="bold" /> Lumi’s voice is off — the video’s sound is set inside the player.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};
